import { render, staticRenderFns } from "./SideContainer.vue?vue&type=template&id=a04f05c0&scoped=true"
import script from "./SideContainer.vue?vue&type=script&lang=js"
export * from "./SideContainer.vue?vue&type=script&lang=js"
import style0 from "./SideContainer.vue?vue&type=style&index=0&id=a04f05c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04f05c0",
  null
  
)

export default component.exports